import React from "react";
import {Dialog} from "@material-ui/core";
import {Button} from "../../Button";
import {strings} from "../../../strings/strings";
import "./index.scss";

interface ITravelNoDataDialogProps {
    isOpen: boolean;
    onSearch: () => void;
    onManual: () => void;
    phoneNumber: string;
}

/*
    Це модалка, що номеру телефону не знайдено
*/

export const TravelNoDataDialog = (props: ITravelNoDataDialogProps) => {
    const {isOpen, phoneNumber, onSearch, onManual} = props;

    return (
        <Dialog open={isOpen} disableBackdropClick={true}>
            <div className={"dialog travel-no-data"}>
                <div className="dialog__content">
                    <span className={"dialog__message"}>{strings.noDataByPhoneDlg.text1}<span>+{phoneNumber}</span> {strings.travelDialog.text5}</span>
                    <span className={"dialog__message"}>{strings.travelDialog.text6}</span>
                    <Button label={strings.travelDialog.text7}
                            onClickListener={onSearch}/>

                    <Button variant={"notSelected"} label={strings.toolbarManual}
                            onClickListener={onManual}/>

                </div>
            </div>
        </Dialog>
    )

}